/*** IMPORTS FROM imports-loader ***/
import Translator from "bazinga-translator";

(function (t) {
// fr
t.add("cart.tickets.no_available_tickets_for_seating", "Il n'y a pas de billets disponibles pour les si\u00e8ges s\u00e9lectionn\u00e9s", "PayseraCartBundle", "fr");
t.add("cart.tickets.no_available_tickets", "Il n'y a pas de billets disponibles", "PayseraCartBundle", "fr");
t.add("paysera_cart.discount.invalid_code", "Code de remise non valide", "PayseraCartBundle", "fr");
})(Translator);
